export default "__VITE_ASSET__hcfn6M4f__"